<template>
    <div class="ClientSingleComment" :class="{'ClientSingleComment--alt': index % 2 === 0 }">
        <div class="ClientSingleComment__authorPhoto">
            <div class="thumbnail">
                <img class="img-responsive user-photo" src="https://randomuser.me/api/portraits/med/men/83.jpg">
            </div>
        </div>
        <div class="ClientSingleComment__authorComment">
            <div class="ClientSingleComment__panel panel panel-default">
                <div class="ClientSingleComment__heading panel-heading">
                    <strong>{{ comment.name }}</strong> <span class="text-muted">{{ lastSeen }} {{comment.lastSeen.date | formatDate}}</span>
                </div>
                <div class="panel-body">
                    <slot/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ClientSingleComment',
  components: {},
  props: {
    comment: Object,
    index: Number
  },
  mounted () {
  },
  computed: {
    lastSeen () {
      return `Last seen in ${this.comment.lastSeen.location}`
    }
  },
  data: () => ({})
}
</script>

<style lang="scss">
    .ClientSingleComment {
        display: flex;
        &__panel {
            position: relative;
        }
        &__authorPhoto {
            margin: 0 15px 0 0;
        }
        &__authorComment {
            width: 100%
        }
        &__heading:after, &__heading:before {
            position: absolute;
            top: 11px;
            left: -16px;
            right: 100%;
            width: 0;
            height: 0;
            display: block;
            content: " ";
            border-color: transparent;
            border-style: solid solid outset;
            pointer-events: none;
        }
        &--alt {
            .ClientSingleComment__authorPhoto {
                margin: 0 0 0 15px;
                order: 2;
            }
            .ClientSingleComment__heading:after, .ClientSingleComment__heading:before {
                left: 100%;
                right: -16px;
            }
        }
        &__heading:after {
            border-width: 7px;
            border-right-color: #f7f7f7;
            margin-top: 1px;
            margin-left: 2px;
        }
        &__heading:before {
            border-right-color: #ddd;
            border-width: 8px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ClientComments/client-single-comment.vue